// extracted by mini-css-extract-plugin
export default {"body":"whereBounds_body__aZdSp","title":"whereBounds_title__r-VkO","text":"whereBounds_text__Ssda6","postText":"whereBounds_postText__FXEcf"};